import { http } from '@/utils/http'
import { useUserStore } from '@/store/user'
import { setStartupReady } from '@/utils/startup'
import { LDBridge } from '@/utils/handleBrdge'
interface WxLoginRes {
  data: {
    openid: string
    [key: string]: any
  }
}

interface WxPhoneRes {
  data: {
    phoneNumber: string
    [key: string]: any
  }
}

interface LoginRes {
  data: {
    token: string
    [key: string]: any
  }
}

const wxphone = (data: object): Promise<WxPhoneRes> => {
  return http.get('/nxcloud-base-wechat/wx/ma/user/LAND-C/10000/phone', data)
}

const login = (data: object): Promise<LoginRes> => {
  return http.post('/nxcloud-app-user/c/mini-c/v1/auth/login', data)
}

const wxlogin = (data: object): Promise<WxLoginRes> => {
  return http.get('/nxcloud-base-wechat/wx/ma/user/LAND-C/10000/login', data)
}

const registerBizUser = (data: object) => {
  return http.post('/nxcloud-app-user/c/mini-c/v1/auth/registerBizUser', data)
}

export const getTokenHK = (data: object) => {
  return http.post<{ token: string }>('/nxcloud-app-user/anon/v1/app/getToken', data)
}




// 临时登录
const registerTemporaryUser = (data: object) => {
  return http.post('/nxcloud-app-user/c/mini-c/v1/auth/registerTemporaryUser', data)
}

// 绑定手机号
const temporaryUserBindPhone = (data: object) => {
  return http.post('/nxcloud-app-user/c/mini-c/v1/auth/temporaryUserBindPhone', data)
}


// 看这个方法也没有用到，可以删除
export const loginByPhoneFn = (e: any): Promise<'success'> => {
  console.log(e, 'e------->>>>>>>>>>>')
  return new Promise(async (resolve, reject) => {
    if (e.detail.errMsg !== 'getPhoneNumber:ok') {
      reject('error')
      return
    }
    // const loginRes = await uni.login()
    // const wxloginres = await wxlogin({ code: loginRes.code })
    const resPhone = await wxphone({ code: e.detail.code })
    const resLogin = await login({
      clientCode: 'LAND_MINI_C',
      type: 'wechatMini',
      userIdent: resPhone.data.phoneNumber,
      code: uni.getStorageSync('openid'),
      authData: {
        inviteCode: uni.getStorageSync('shareCode') && uni.getStorageSync('shareCode'),
        type: uni.getStorageSync('shareType'),
      },
    })

    //console.log(resLogin, 'resLogin')
    uni.setStorageSync('token', resLogin.data.token)
    uni.setStorageSync('phoneNumber', resPhone.data.phoneNumber)
    uni.setStorageSync('userKey', resLogin.data.userKey)
    resolve('success')
  })
}

// 小程序手机号&验证码登录
export const loginByCode = (data: object): Promise<'success'> => {
  return new Promise(async (resolve, reject) => {
    const resLogin = await login(data)
    uni.setStorageSync('token', resLogin.data.token)
    uni.setStorageSync('phoneNumber', data.userIdent)
    uni.setStorageSync('userKey', resLogin.data.userKey)
    const userStore = useUserStore()
    userStore.setLogin(resLogin.data.token)
    userStore.setPhoneNum(data.userIdent)
    resolve('success')
  })
}


// 小程序一键登录
export const loginByPhone = (e: any): Promise<'success'> => {
  return new Promise(async (resolve, reject) => {
    if (e.detail.errMsg !== 'getPhoneNumber:ok') {
      reject('error')
      return
    }
    // const loginRes = await uni.login()
    // const wxloginres = await wxlogin({ code: loginRes.code })
    const resPhone = await wxphone({ code: e.detail.code })
    const resLogin = await login({
      clientCode: 'LAND_MINI_C',
      type: 'wechatMini',
      userIdent: resPhone.data.phoneNumber,
      code: uni.getStorageSync('openid'),
      authData: {
        inviteCode: uni.getStorageSync('shareCode') && uni.getStorageSync('shareCode'),
        type: uni.getStorageSync('shareType'),
      },
    })

    //console.log(resLogin, 'resLogin')
    uni.setStorageSync('token', resLogin.data.token)
    uni.setStorageSync('phoneNumber', resPhone.data.phoneNumber)
    uni.setStorageSync('userKey', resLogin.data.userKey)
    const userStore = useUserStore()
    userStore.setLogin(resLogin.data.token)
    userStore.setPhoneNum(resPhone.data.phoneNumber)
    resolve('success')
  })
}

// 临时登录后没有手机号，绑定手机号
export const bindPhone = (e: any): Promise<'success'> => {
  return new Promise(async (resolve, reject) => {
    if (e.detail.errMsg !== 'getPhoneNumber:ok') {
      reject('error')
      return
    }
    const resPhone = await wxphone({ code: e.detail.code })
    const resLogin = await temporaryUserBindPhone({
      userKey: uni.getStorageSync('userKey'),
      phone: resPhone.data.phoneNumber,
    })

    uni.setStorageSync('token', resLogin.data.token)
    uni.setStorageSync('phoneNumber', resPhone.data.phoneNumber)
    uni.setStorageSync('userKey', resLogin.data.userKey)
    const userStore = useUserStore()
    userStore.setLogin(resLogin.data.token)
    userStore.setPhoneNum(resPhone.data.phoneNumber)
    resolve('success')
  })
}

// 进入小程序即触发，临时登录，没有手机号，需要获取微信手机号
export const getRegisterBizUser = async (data: object) => {
  const loginRes = await uni.login()
  const wxloginres = await wxlogin({ code: loginRes.code })
  uni.setStorageSync('openid', wxloginres.data.openid)
  // 进入小程序获取openid后，临时登录
  const res = await registerTemporaryUser({
    clientCode: 'LAND_MINI_C',
    type: 'wechatMini',
    userIdent: '',
    code: wxloginres.data.openid,
    authData: {
      inviteCode: uni.getStorageSync('shareCode') && uni.getStorageSync('shareCode'),
      type: uni.getStorageSync('shareType'),
    },
  })
  if (res.code == 0) {
    uni.setStorageSync('userKey', res?.data?.userKey)
    uni.setStorageSync('token', res?.data?.token)
    uni.setStorageSync('phoneNumber', res?.data?.phoneNum)
    const userStore = useUserStore()
    userStore.setLogin(res?.data?.token)
    userStore.setPhoneNum(res?.data?.phoneNum)
    setStartupReady();
  }
}

export async function relogin(): Promise<'success'> {
  const loginRes = await uni.login()
  const wxloginres = await wxlogin({ code: loginRes.code })
  uni.setStorageSync('openid', wxloginres.data.openid)

  const phoneNumber = uni.getStorageSync('phoneNumber')

  // 没有手机号时走临时登录
  if (!phoneNumber) {
    const res = await registerTemporaryUser({
      clientCode: 'LAND_MINI_C',
      type: 'wechatMini',
      userIdent: '',
      code: wxloginres.data.openid,
      authData: {
        inviteCode: uni.getStorageSync('shareCode') && uni.getStorageSync('shareCode'),
        type: uni.getStorageSync('shareType'),
      },
    })
    uni.setStorageSync('userKey', res?.data?.userKey)
    uni.setStorageSync('token', res?.data?.token)
    uni.setStorageSync('phoneNumber', res?.data?.phoneNum)
    const userStore = useUserStore()
    userStore.setLogin(res?.data?.token)
    userStore.setPhoneNum(res?.data?.phoneNum)
    return 'success'
  }

  // 有手机号时走正常登录
  const resLogin = await login({
    clientCode: 'LAND_MINI_C',
    type: 'wechatMini',
    userIdent: phoneNumber,
    code: wxloginres.data.openid,
    authData: {
      inviteCode: uni.getStorageSync('shareCode') && uni.getStorageSync('shareCode'),
      type: uni.getStorageSync('shareType'),
    },
  })
  uni.setStorageSync('token', resLogin.data.token)
  uni.setStorageSync('userKey', resLogin.data.userKey)
  const userStore = useUserStore()
  userStore.setLogin(resLogin.data.token)
  return 'success'
}

export const loginOut = () => {
  const userStore = useUserStore()
  userStore.setLogin('')
  clearStoreData()
}

export const clearStoreData = () => {
  uni.removeStorageSync('token')
  uni.removeStorageSync('userKey')
  uni.removeStorageSync('phoneNumber')
  const userStore = useUserStore()
  userStore.setLogin('')
  userStore.setPhoneNum('')
}

export const HKLogin = (flag = false) => {
  //console.log('清除登录信息')
  // uni.removeStorageSync('tokenHK')
  // uni.removeStorageSync('token')
  // uni.removeStorageSync('email')
  // uni.removeStorageSync('customerId')
  // console.log('清除后第一次tokenHK',uni.getStorageSync('tokenHK'))
  // console.log('清除后第一次token',uni.getStorageSync('tokenHK'))
  // console.log('清除后第一次email',uni.getStorageSync('email'))
  // console.log('清除后第一次customerId',uni.getStorageSync('customerId'))

  return new Promise(async (resolve, reject) => {
    // getTokenHK({
    //   "authClient": "H5-C",
    //   "authType": "YAICHI",
    //   "clientCode": "YAICHI_APPID_0001",
    //   "userIdent": '12312321'
    // }).then(res=>{
    //   uni.setStorageSync('token',res.data.token)
    //   uni.setStorageSync('tokenHK','eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImlkIjoiY3VzdG9tZXJfWk9zZUd4bXBLU2FJSGhxY0lrNkEiLCJpbmNyZW1lbnRJZCI6IkMwMDAwMDIwNjE0IiwidXNlcm5hbWUiOiJ6aG9uZ2J5NjZAZ21haWwuY29tIiwicm9sZSI6ImN1c3RvbWVyIiwiaXNOZXciOmZhbHNlfSwiaWF0IjoxNzcyNjk2ODE2LCJleHAiOjE4MDQyMzI4MTYsInN1YiI6ImFjY2Vzc190b2tlbiJ9.vP7ZBUZOod6K9addq44nU_x3tK2aj56U9o0TX-xB8xE')
    //   resolve('success')
    // })
    // console.log('HKLoginHKLoginHKLoginHKLoginHKLogin123') 
    // return
    try {
      const bridgeUserInfo = await LDBridge.userInfo({})
      const tokenHK = bridgeUserInfo.tokenHK
      const token = bridgeUserInfo.token
      if (tokenHK && token) {
        uni.setStorageSync('tokenHK', tokenHK)
        uni.setStorageSync('token', token)
        resolve('success')
        return
      }
    }
    catch (error) {
      console.warn('從原生橋接取得香港帳號資訊失敗，回退既有登入流程:', error)
    }

    if (!window.ReactNativeWebView) {
      const tokenHK = uni.getStorageSync('tokenHK')
      const token = uni.getStorageSync('token')
      if (tokenHK && token) {
        resolve('success')
      } else {
        console.log('【window.ReactNativeWebView】error')
        reject('【window.ReactNativeWebView】 error')
      }

    }
    window.ReactNativeWebView.postMessage(JSON.stringify({type: 'getUserInfo',payload:{}}));
    window.addEventListener('onRNMessage', function (e) {
      // console.log('HKLoginHKLoginHKLoginHKLoginHKLogin',e)
      //alert(JSON.stringify(e))
      const { type, payload } = e.detail || {};
      // 业务逻辑处理
      console.log('消息类型:', type); 
      console.log('消息类型:', payload); 
      console.log('用户Token:', payload.userToken);   
      console.log('邮箱:', payload.email);       
      console.log('客户ID:', payload.customerId); 
      const userNickName = `${payload.firstName || ''} ${payload.lastName || ''}`
      uni.setStorageSync('tokenHK',payload.userToken)
      uni.setStorageSync('email',payload.email)
      uni.setStorageSync('customerId',payload.customerId)
      uni.setStorageSync('userNickName', userNickName)
      if(flag){
        return resolve('success')
      }
      getTokenHK({
        "authClient": "H5-C",
        "authType": "YAICHI",
        "clientCode": "YAICHI_APPID_0001",
        "userIdent": payload.email,
        "customerId": payload.customerId,
        userNickName,
      }).then(res=>{
        uni.setStorageSync('token',res.data.token)
        resolve('success')
      })
    });
    
  })
}
